import {
  SandpackConsole,
  SandpackFiles,
  SandpackPreview,
  useSandpack,
} from "@codesandbox/sandpack-react";
import { useSandpackRun } from "./useSandpackRun";

export default function SandpackPreviewWithConsole({
  setFiles,
}: {
  setFiles: (s: SandpackFiles) => void;
}) {
  const { sandpack } = useSandpack();

  useSandpackRun(() => setFiles(sandpack.files));

  return (
    <>
      <SandpackPreview className="!hidden" />
      <SandpackConsole className="!h-full" showSyntaxError={true} />
    </>
  );
}
